<div class="settlement card summary sticky-summary">
  <h2 class="settlement__title">{{ title }}</h2>

  @if (hint) {
    <p class="settlement__hint">{{ hint }}</p>
  }

  <div class="settlement__row">
    <span>{{ baseLabel }}</span>
    <span class="tabular-nums">{{ baseAmount | number: '1.2-2' }} {{ currencyLabel }}</span>
  </div>

  @for (row of extraRows; track row.label) {
    <div class="settlement__row" [class.under]="row.tone === 'under'" [class.over]="row.tone === 'over'" [class.muted]="row.tone === 'muted'" [class.send]="row.tone === 'send'">
      <span>{{ row.label }}</span>
      <span class="tabular-nums">{{ row.value | number: '1.2-2' }} {{ currencyLabel }}</span>
    </div>
  }

  @if (bankingFee) {
    <div class="settlement__row settlement__row--fee">
      <span>{{ bankingFeeLabel }}</span>
      <span class="tabular-nums">{{ feeSign }} {{ bankingFee | number: '1.2-2' }} {{ currencyLabel }}</span>
    </div>
  }
  @if (securityFee) {
    <div class="settlement__row settlement__row--fee">
      <span>{{ securityFeeLabel }}</span>
      <span class="tabular-nums">{{ feeSign }} {{ securityFee | number: '1.2-2' }} {{ currencyLabel }}</span>
    </div>
  }

  <div class="settlement__total">
    <span>{{ netLabel }}</span>
    <strong class="tabular-nums">{{ net | number: '1.2-2' }} {{ currencyLabel }}</strong>
  </div>
</div>
